import {
	DafAnonymousAuthStrategy,
	DafExchangeStrategy,
	AuthStrategy,
	DafOnboardingAuthStrategy,
	DafTokenRefreshStrategy,
	DafTransactionStepUpAuthStrategy,
	SeedTokenProviderWrapperStrategy,
} from '@nab/x-runtime';
import { CustomNabCAuthStrategy } from './custom-nabc-auth-strategy';
import { CustomDAFUsernamePwdStrategy } from './custom-daf-username-pwd-auth-strategy';
import { CustomDafProspectLoginStrategy } from './custom-daf-prospect-login-auth-strategy';
import { CustomDafStepUpAuthStrategy } from './custom-daf-step-up-auth-strategy';
import { getTokenCacheStrategy } from 'runtime/auth-token-cache-strategy';
import {
	customStepUpConfig,
	onboardingConfig,
	refreshConfig,
	prospectLoginConfig,
	userPassConfig,
	transactionStepUpConfig
} from './auth-configs';

const getAuthStrategies = (config): Array<AuthStrategy> => {
	const { clientId, dafEndpoint, isAuthRequired, assetManifestUrl, tenant, environment, external } = config;
	return isAuthRequired
		? ([
			new DafTransactionStepUpAuthStrategy(transactionStepUpConfig(tenant, assetManifestUrl)),
			new CustomDafProspectLoginStrategy(prospectLoginConfig(clientId, tenant, environment, assetManifestUrl, external)),
			new CustomDAFUsernamePwdStrategy(userPassConfig(clientId, tenant, environment, assetManifestUrl, external)),
			new CustomNabCAuthStrategy(dafEndpoint, clientId, true),
			new CustomDafStepUpAuthStrategy(customStepUpConfig(assetManifestUrl, tenant, clientId)),
			new DafOnboardingAuthStrategy(onboardingConfig(clientId, assetManifestUrl, tenant, external)),
			new DafTokenRefreshStrategy(dafEndpoint, refreshConfig(clientId, tenant, external)),
			new DafAnonymousAuthStrategy(dafEndpoint, clientId, true),
			new SeedTokenProviderWrapperStrategy(
				async () => {
					const seedToken = getTokenCacheStrategy().authTokenCacheStrategy.getSeedToken();
					return Promise.resolve(seedToken?.token?.tokenValue);
				},
				{
					context: 'external',
					tokenType: 'Bearer',
					tokenSource: 'DAF',
				}
			),
			new DafExchangeStrategy(dafEndpoint),
		] as Array<AuthStrategy>)
		: [];
};

export const getAuthStrategiesRuntime = (config) => {
	return {
		authStrategies: getAuthStrategies(config),
	};
};
